export const currencyFrag = `
    id
    code
    name
    isDefault
`;
